export default IconOmega => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-omega" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 19h5v-1a7.35 7.35 0 1 1 6 0v1h5" />
</svg>`;